import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

import { getBaseUrl } from "../../service/apiUrl";
export const STATUSES = Object.freeze({
  IDLE: "idle",
  ERROR: "error",
  LOADING: "loading",
});

const getHorseStatsSlice = createSlice({
  name: "horsestats",
  initialState: {
    data: [],
    status: STATUSES.IDLE,
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchHorseStats.pending, (state, action) => {
        state.status = STATUSES.LOADING;
      })
      .addCase(fetchHorseStats.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = STATUSES.IDLE;
      })
      .addCase(fetchHorseStats.rejected, (state, action) => {
        state.status = STATUSES.ERROR;
      });
  },
});

export const { setTrainer, setStatus } = getHorseStatsSlice.actions;
export default getHorseStatsSlice.reducer;

export const fetchHorseStats = createAsyncThunk(
  "/horsestats/fetch",
  async ({
    year,
    StartDate,
    EndDate,
    RaceCourseSearch,
    HorseKindSearch,
    TrackLengthSearch,
    RaceTypeSearch,
    RaceKindSearch,
    RaceGroundSearch,
    RaceNationalitySearch,
    currentPage,
  }) => {
    const token = Cookies.get("token");
    const baseUrl = getBaseUrl().replace(/\/+$/, "");
    const headers = {};
    if (token && token !== "undefined") {
        headers.Authorization = token;
        headers["x-xsrf-token"] = token;
    }
    const res = await axios.get(
      `${baseUrl}/HorseStatsistics?year=${
        year === undefined ? "" : year
      }&startTimeTo=${StartDate}&startTimeFrom=${EndDate}&RaceCourse=${RaceCourseSearch}&HorseKindinRace=${HorseKindSearch}&TrackLength=${TrackLengthSearch}&RaceType=${RaceTypeSearch}&RaceKind=${RaceKindSearch}&NationalityID=${RaceNationalitySearch}&Ground=${RaceGroundSearch}&page=${currentPage}`,
      { headers }
    );
    const trainerstatsData = res.data;
    return trainerstatsData;
  }
);
